import common from './common';

const homeDomain = 'customer.local.xfinity.com:5000';
const mobileDomain = 'mcx-staging.dss-ops.xfinity.com/mobile';

const CONFIG = {
  ...common,
  ...process.env,
  homeDomain,
  mobileDomain,
  billServicesUrl: `https://${homeDomain}/billing/services`,
  billingUrl: `https://${homeDomain}/billing`,
  billingMobileUrl: `https://${homeDomain}/billing/mobile`,
  billingMobileTransactionsUrl: `https://${homeDomain}/billing/mobile/transactions`,
  makePaymentUrl: `https://${homeDomain}/new`,
  cwaRoot: 'https://staging-static.cimcontent.net/common-web-assets/',
  paymentSetup: {
    ...common.paymentSetup,
    // Where to go if no continueUrl specified (from consent flow)
    defaultContinue: `https://${homeDomain}/`,
  },
  shelbyCMSUrl: 'https://sdx.qa.xfinity.com/cms/data/',
  collectionsBack: 'https://www.stg.xfinity.com/buy/plan/xap',
  oauthUrl: 'https://oauth-st.xfinity.com',
  nowMobileUrl: `https://${mobileDomain}/my-account/now/activity`,
  xmMyAccountUrl: `https://${mobileDomain}/my-account`,
  devicesMobileUrl: `https://${mobileDomain}/my-account/devices`,
};

export default CONFIG;
